import { Grid, TextField, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

/**
 * 비밀번호 입력 컴포넌트
 * @param {string} passwordLabel - password placeholder(label) text
 * @param {String} rePasswordLabel - re password placeholder(label) text
 * @param {function} onChange - password onChange event fun
 * @param {boolean} regExp - password regExp check value
 * @param {boolean} regExp2 - re password regExp check value
 * @param {string} password - password, value
 * @param {String} rePassword - re password value
 * @param {function} onChangePassword - change password btn click event fun
 * @param {string}   changeButtonText - change button text
 * @param {boolean} isFindPasswordPage - Is this page Find password Page?
 * @returns
 */
function PasswordInput({
  passwordLabel,
  rePasswordLabel,
  onChange,
  regExp,
  regExp2,
  password,
  rePassword,
  onChangePassword,
  changeButtonText,
  isFindPasswordPage = false,
}) {
  const { t } = useTranslation(['page']);

  const isPasswordNotEmpty = password !== '' && password.length !== 0;
  const isRePasswordNotEmpty = rePassword !== '' && rePassword.length !== 0;
  const isShownPasswordNotMatchError = rePassword !== password && isRePasswordNotEmpty;
  const isShownNotValidError = !regExp && isPasswordNotEmpty;
  const isEnablePassword = regExp && isPasswordNotEmpty;
  const isEqualPassword = isPasswordNotEmpty && isRePasswordNotEmpty && password === rePassword;
  return (
    <>
      <Grid item xs={12} style={{ position: 'relative', marginTop: '20px' }}>
        <TextField
          required
          fullWidth
          type="password"
          id="password"
          name="password"
          label={passwordLabel}
          onKeyUp={onChange}
        />
        {isShownNotValidError ? (
          <PasswordText style={{ fontSize: 'smaller', color: 'red' }}>
            {t('8자 이상 영문, 숫자, 특수문자가 조합되어야합니다.')}
          </PasswordText>
        ) : null}
        {isEnablePassword ? (
          <PasswordText style={{ fontSize: 'smaller', color: 'blue' }}>
            {t('사용가능한 비밀번호 입니다.')}{' '}
          </PasswordText>
        ) : null}
      </Grid>

      <Grid item xs={12} style={{ position: 'relative' }}>
        <TextField
          required
          fullWidth
          type="password"
          id="rePassword"
          name="rePassword"
          label={rePasswordLabel}
          onChange={onChange}
        />
        {isShownPasswordNotMatchError && (
          <PasswordText style={{ fontSize: 'smaller', color: 'red' }}>
            {t('비밀번호가 일치하지 않습니다.')}
          </PasswordText>
        )}
        {isEqualPassword ? (
          <PasswordText style={{ fontSize: 'smaller', color: 'blue' }}>{t('비밀번호가 일치합니다.')}</PasswordText>
        ) : null}
      </Grid>
      {isFindPasswordPage && (
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          size="large"
          disabled={!(isEnablePassword && isEqualPassword)}
          onClick={onChangePassword}
          style={{ marginLeft: '16px' }}
        >
          {changeButtonText}
        </Button>
      )}
    </>
  );
}
const PasswordText = styled('p')({
  position: 'absolute',
  right: '16px',
  top: '50%',
});

export default PasswordInput;
